// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25dQ8","content":"styles_content__3-msn","tableWrap":"styles_tableWrap__1snzx"};